<template>
  <div class="main">
    <van-nav-bar title="视频中心" left-text="首页" left-arrow v-if="isHeadShow" @click-left="onClickLeft">
      <template #right>
        <van-icon name="search" size="18" @click="serchShow()" />
      </template>
    </van-nav-bar>
    <van-search
      v-model="value"
      show-action
      placeholder="请输入搜索关键词"
      @search="onSearch"
      @cancel="onCancel"
      v-if="isSerchShow"
    />
    <van-image src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/banner/videobanner.png"></van-image>

    <!-- <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="banner in banners" :key="banner.index">
        <router-link :to="banner.to">
           <van-image
          :src="banner.img"
        />
        </router-link>
      </van-swipe-item>
    </van-swipe>-->
    <van-tabs v-model="active" @click="tabClick" swipe-threshold="6">
      <van-tab title="推荐" name="1">
        <div class="video" v-for="data in datas" :key="data.id" @click="to(data.id)">
          <div
            class="video-content"
            :style="{
              background: '#eee',
              width: videoWidth,
              height: videoHeight,
              position:'relative'
            }"
          >
            <div
              class="video-info-orther-type"
            >{{data.time}}&nbsp;&nbsp;{{data.views}}万观看&nbsp;&nbsp;</div>
            <img :src="data.cover_url" class="cover-img" alt />
            <img src="../../icons/play.png" class="video-icon" alt />
          </div>
          <div class="video-info">
            <div class="video-info-title">{{data.title}}</div>
            <div class="video-info-orther">
              <div class="video-info-orther-left">
                <van-tag plain color="#000" style="margin-right:5px">{{data.type_desc}}</van-tag>
                <van-tag
                  plain
                  type="success"
                  v-for="one in data.tags"
                  :key="one.index"
                  style="margin-right:5px"
                >{{one}}</van-tag>
              </div>
              <div class="video-info-orther-num">{{data.create_time}}</div>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="热门" name="2">
        <div class="video" v-for="data in datas" :key="data.id" @click="to(data.id)">
          <div
            class="video-content"
            :style="{
              background: '#eee',
              width: videoWidth,
              height: videoHeight,
              position:'relative'
            }"
          >
            <div
              class="video-info-orther-type"
            >{{data.time}}&nbsp;&nbsp;{{data.views}}万观看&nbsp;&nbsp;</div>
            <img :src="data.cover_url" class="cover-img" alt />
            <img src="../../icons/play.png" class="video-icon" alt />
          </div>
          <div class="video-info">
            <div class="video-info-title">{{data.title}}</div>
            <div class="video-info-orther">
              <div class="video-info-orther-left">
                <van-tag plain color="#000" style="margin-right:5px">{{data.type_desc}}</van-tag>
                <van-tag
                  plain
                  type="success"
                  v-for="one in data.tags"
                  :key="one.index"
                  style="margin-right:5px"
                >{{one}}</van-tag>
              </div>
              <div class="video-info-orther-num">{{data.create_time}}</div>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="西点" name="3">
        <div class="video" v-for="data in datas" :key="data.id" @click="to(data.id)">
          <div
            class="video-content"
            :style="{
              background: '#eee',
              width: videoWidth,
              height: videoHeight,
              position:'relative'
            }"
          >
            <div
              class="video-info-orther-type"
            >{{data.time}}&nbsp;&nbsp;{{data.views}}万观看&nbsp;&nbsp;</div>
            <img :src="data.cover_url" class="cover-img" alt />
            <img src="../../icons/play.png" class="video-icon" alt />
          </div>
          <div class="video-info">
            <div class="video-info-title">{{data.title}}</div>
            <div class="video-info-orther">
              <div class="video-info-orther-left">
                <van-tag plain color="#000" style="margin-right:5px">{{data.type_desc}}</van-tag>
                <van-tag
                  plain
                  type="success"
                  v-for="one in data.tags"
                  :key="one.index"
                  style="margin-right:5px"
                >{{one}}</van-tag>
              </div>
              <div class="video-info-orther-num">{{data.create_time}}</div>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="西餐" name="4">
        <div class="video" v-for="data in datas" :key="data.id" @click="to(data.id)">
          <div
            class="video-content"
            :style="{
              background: '#eee',
              width: videoWidth,
              height: videoHeight,
              position:'relative'
            }"
          >
            <div
              class="video-info-orther-type"
            >{{data.time}}&nbsp;&nbsp;{{data.views}}万观看&nbsp;&nbsp;</div>
            <img :src="data.cover_url" class="cover-img" alt />
            <img src="../../icons/play.png" class="video-icon" alt />
          </div>
          <div class="video-info">
            <div class="video-info-title">{{data.title}}</div>
            <div class="video-info-orther">
              <div class="video-info-orther-left">
                <van-tag plain color="#000" style="margin-right:5px">{{data.type_desc}}</van-tag>
                <van-tag
                  plain
                  type="success"
                  v-for="one in data.tags"
                  :key="one.index"
                  style="margin-right:5px"
                >{{one}}</van-tag>
              </div>
              <div class="video-info-orther-num">{{data.create_time}}</div>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="咖啡" name="5">
        <div class="video" v-for="data in datas" :key="data.id" @click="to(data.id)">
          <div
            class="video-content"
            :style="{
              background: '#eee',
              width: videoWidth,
              height: videoHeight,
              position:'relative'
            }"
          >
            <div
              class="video-info-orther-type"
            >{{data.time}}&nbsp;&nbsp;{{data.views}}万观看&nbsp;&nbsp;</div>
            <img :src="data.cover_url" class="cover-img" alt />
            <img src="../../icons/play.png" class="video-icon" alt />
          </div>
          <div class="video-info">
            <div class="video-info-title">{{data.title}}</div>
            <div class="video-info-orther">
              <div class="video-info-orther-left">
                <van-tag plain color="#000" style="margin-right:5px">{{data.type_desc}}</van-tag>
                <van-tag
                  plain
                  type="success"
                  v-for="one in data.tags"
                  :key="one.index"
                  style="margin-right:5px"
                >{{one}}</van-tag>
              </div>
              <div class="video-info-orther-num">{{data.create_time}}</div>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="调酒" name="6">
        <div class="video" v-for="data in datas" :key="data.id" @click="to(data.id)">
          <div
            class="video-content"
            :style="{
              background: '#eee',
              width: videoWidth,
              height: videoHeight,
              position:'relative'
            }"
          >
            <div
              class="video-info-orther-type"
            >{{data.time}}&nbsp;&nbsp;{{data.views}}万观看&nbsp;&nbsp;</div>
            <img :src="data.cover_url" class="cover-img" alt />
            <img src="../../icons/play.png" class="video-icon" alt />
          </div>
          <div class="video-info">
            <div class="video-info-title">{{data.title}}</div>
            <div class="video-info-orther">
              <div class="video-info-orther-left">
                <van-tag plain color="#000" style="margin-right:5px">{{data.type_desc}}</van-tag>
                <van-tag
                  plain
                  type="success"
                  v-for="one in data.tags"
                  :key="one.index"
                  style="margin-right:5px"
                >{{one}}</van-tag>
              </div>
              <div class="video-info-orther-num">{{data.create_time}}</div>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <div style="width:100%;height:60px"></div>
    <div class="footer">
      <div class="footer-left">
        <van-button color="#ff0000" plain style="width:100%;" to="/course">拨打热线</van-button>
      </div>
      <div class="footer-right">
        <van-button color="#ff0000" style="width:100%;border-radius:2px;" to="/chat">在线咨询</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import DPlayer from "dplayer";
export default {
  data() {
    return {
      apiUrl: "http://api.cdomick.com/index.php/",
      // apiUrl:'http://localhost/index.php/',
      isSerchShow: false,
      isHeadShow: true,
      videoWidth: "414px",
      videoHeight: "232.875px",
      active: "1",
      datas: [],
      banners: [
        {
          img:
            "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/banner/pc_banner_20200509.jpg",
          to: "chat"
        },
        {
          img:
            "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/banner/pc_banner_20200129.jpg",
          to: "chat"
        }
      ]
    };
  },
  methods: {
    tabClick(index) {
      this.getlist(index);
    },
    getlist(index) {
      let url = this.apiUrl;

      this.$axios
        .get(url + "video/list", {
          params: {
            index: index
          }
        })
        .then(response => {
          this.datas = response.data.data;
        });
    },
    to(id) {
      let active = this.active;
      this.$router.push({ path: `/vdetail/active/${active}/id/${id}` });
    },
    serchShow() {
      this.isSerchShow = true;
      this.isHeadShow = false;
    },
    onCancel() {
      this.isSerchShow = false;
      this.isHeadShow = true;
    },
    getVideoHeight() {
      let width = document.body.clientWidth;
      let height = (width * 9) / 16;
      this.videoWidth = width + "px";
      this.videoHeight = height + "px";
    },
    // getActive(){
    //   console.log(this.$route.params.active)
    //   this.active = this.$route.params.active;
    // },
    height() {
      window.scrollTo(100, 500);
    },
    onClickLeft() {
      this.$router.push({ path: `/` });
    }
  },
  mounted() {
    this.getVideoHeight();
    // this.getActive()
    this.getlist(1);
    // this.height();
  },
  created() {}
};
</script>

<style lang="less" scoped>
/deep/ .van-search__content {
  background-color: #dbdee2;
}
/deep/ .container {
  padding: 0;
}
.footer {
  width: 100%;
  height: 60px;
  padding: 6px 0;
  position: fixed;
  background: #fff;
  bottom: 0;
}
.footer-left {
  width: 50%;

  float: left;
  height: 50px;
  padding: 2px 5px 2px 10px;
}
.footer-right {
  width: 50%;
  float: left;
  height: 50px;
  padding: 2px 10px 2px 5px;
}
.video {
  width: 100%;
  background: #fff;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}
.video-info {
  width: 100%;
  height: 7vh;
  padding: 0px 10px;
}
.video-info-title {
  width: 100%;
  height: 4vh;
  line-height: 4vh;
  font-size: 14px;
  font-weight: 600;
}
.video-info-orther {
  width: 100%;
  height: 3vh;
}
.video-info-orther-type {
  width: 100%;
  height: 3vh;
  color: #000;
  position: absolute;
  color: #fff;
  background: rgba(0, 0, 0, 0.3);
  text-indent: 10px;
  bottom: 0;
  line-height: 3vh;
  font-size: 12px;
  float: left;
}
.video-info-orther-num {
  width: 50%;
  height: 3vh;
  line-height: 3vh;
  font-size: 12px;
  float: right;
  text-align: right;
}
.video-icon {
  width: 48px;
  position: absolute;
  bottom: 24px;
  right: 4px;
  height: 48px;
}
.cover-img {
  width: 100%;
  height: 100%;
}
.video-info-orther-left {
  width: 50%;
  height: 3vh;
  line-height: 3vh;
  float: left;
  font-size: 12px;
  text-align: left;
}
</style>
